import React, { useState, Fragment } from 'react';
import PageContainer from '../../@jumbo/components/PageComponents/layouts/PageContainer';
import { Button, CircularProgress, makeStyles, Backdrop } from '@material-ui/core';
import { API_AUTH, AUTH_ORIGEN } from '../../config/config';
import axios from 'axios';

import { CustomToast, toast } from '@jumbo/components/custom/Toast';

import claveunica from '../../images/claveunica.svg';
import './login.css';
import ModalTokenIngreso from './ModalTokenIngreso';

const useStyle = makeStyles(theme => ({
  errors: {
    color: 'red',
    fontHeight: 'bold',
  },
  contenedorLogin: {
    background: 'white',
    marginTop: '80px',
    borderRadius: '5px',
    maxWidth: '100%',
    width: '400px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },

  btnclave: {
    backgroundColor: '#0073ba',
  },
}));

const Redirection = () => {
  const [spinner, setSpinner] = useState(false);
  const classes = useStyle();
  const [showModalToken, setShowModalToken] = useState(false)

  const prevent = event => {
    event.preventDefault();
  };

  const redirect = () => {
    setSpinner(true);
    axios
      .get(`${API_AUTH}urclave/${AUTH_ORIGEN}`)
      .then(res => {
        window.location.href = res.data;
        setSpinner(true);
      })
      .catch(res => {
        toast.error('Error al cargar la pagina');
        setSpinner(false);
      });
  };

  const closeModalToken = () => {
    setShowModalToken(false)
  }

  return (
    <Fragment>
      <CustomToast />
      <Backdrop
        className={classes.backdrop}
        open={spinner}
        onClick={event => {
          prevent(event);
        }}>
        <CircularProgress />
        <ModalTokenIngreso
          openDialog={showModalToken}
          close={closeModalToken}
        />
      </Backdrop>

      <PageContainer heading={''}>
        {/*         Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
        aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        <Button onClick={redirect}>Ir</Button> */}

        <div className={classes.contenedorLogin}>
          <div className={classes.contenedorLogin + ' shadow'}>
            <div className="titulo-login">
              <h1 className="py-2">Extranet Superintendencia de Salud</h1>
            </div>

            <form className="form-login">
              <p className="text-center my-2" style={{ fontSize: 12, textAlign: 'center', margin: 10 }}>
                Puedes acceder con tu clave única
              </p>

              <Button
                color="primary"
                className="btn-login-ss elementos-login-ss mx-auto my-2"
                onClick={redirect}
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginTop: 10,
                  marginBottom: 10,
                }}>
                <img src={claveunica} alt="Imagen clave unica Superintendencia De Salud" /> CLAVE ÚNICA
              </Button>

              <div style={{ margin: 10, textAlign: 'center' }}>
                <a
                  href="https://claveunica.gob.cl/"
                  className="mx-auto"
                  style={{ color: '#0064ac', marginLeft: 'auto', width: '100%' }}>
                  ¿No tienes clave única?
                </a>
              </div>
              <div style={{ margin: 10, textAlign: 'center' }}>
                <p
                  onClick={() => { setShowModalToken(true) }}
                  className="mx-auto"
                  style={{ color: '#0064ac', marginLeft: 'auto', width: '100%', cursor: 'pointer' }}>
                  Acceder por correo electrónico
                </p>
              </div>
            </form>
          </div>
        </div>
      </PageContainer>
    </Fragment>
  );
};

export default Redirection;
